export default __webpack_public_path__ + "static/tin-9cf08df1df1ea46024afada67d7e8efd.png";